import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PUBLIC_REGISTRATION_ENABLED, showSelfRegistrationDisabledToast } from "@/lib/registration";

/** CTA that links to signup when public registration is enabled, otherwise shows the info toast. */
export function PublicSignupCta({ to = "/signup", children, buttonProps = {}, linkClassName }) {
  if (PUBLIC_REGISTRATION_ENABLED) {
    return (
      <Link to={to} className={linkClassName}>
        <Button {...buttonProps}>{children}</Button>
      </Link>
    );
  }
  return (
    <Button
      type="button"
      {...buttonProps}
      onClick={(e) => {
        buttonProps.onClick?.(e);
        showSelfRegistrationDisabledToast();
      }}
    >
      {children}
    </Button>
  );
}

PublicSignupCta.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node,
  buttonProps: PropTypes.object,
  linkClassName: PropTypes.string,
};
